module.exports = __webpack_public_path__ + "static/media/12.71aa7af7.jpg";